export default {
  hasRightToAddOffer: 'ADD_OFFER',
  hasRightToEditGeneralData: 'EDIT_GENERAL_DATA',
  hasRightToCopyDataFromFinancingOffer: 'COPY_DATA_FROM_FINANCING_OFFER',
  hasRightToEditInsuranceData: 'EDIT_INSURANCE_DATA',
  hasRightToViewInsuredOrUser: 'VIEW_INSURED_USER_DATA',
  hasRightToEditInsuredOrUser: 'EDIT_INSURED_USER_DATA',
  hasRightToViewDrivers: 'VIEW_DRIVERS',
  hasRightToEditDrivers: 'EDIT_DRIVERS',
  hasRightToViewVehicle: 'VIEW_VEHICLE_DATA',
  hasRightToEditVehicle: 'EDIT_VEHICLE_DATA',
  hasRightToAddCascoQuotation: 'CASCO_ADD_QUOTATION',
  hasRightToUpdateCascoQuotationLock: 'CASCO_LOCK_QUOTATION',
  hasRightToSaveEmptyAdditionalData: 'CASCO_ALLOW_EMPTY_ADDITIONAL_DATA',
  hasRightToSelectQuotation: 'SELECT_QUOTATION',
  hasRightToRecomputeQuotation: 'RECOMPUTE_QUOTATION',
  hasRightToRecomputeQuotations: 'RECOMPUTE_QUOTATIONS',
  hasRightToViewOffersHistory: 'VIEW_OFFERS_HISTORY',
  hasRightToViewOfferData: 'VIEW_OFFER_DATA',
  hasRightToEditOfferData: 'EDIT_OFFER_DATA',
  hasRightToEditPolicyDataCard: 'EDIT_POLICY_DATA',
  hasRightToViewWarningArea: 'VIEW_WARNING_AREA',
  hasRightToViewExportDocuments: 'VIEW_EXPORT_DOCUMENTS',
  hasRightToPrintDocuments: 'PRINT_DOCUMENTS',
  hasRightToSignDocuments: 'SIGN_DOCUMENTS',
  hasRightToResetDocumentSigning: 'RESET_DOCUMENT_SIGNING',
  hasRightToViewUploadDocuments: 'VIEW_UPLOAD_DOCUMENTS',
  hasRightToEditUploadDocuments: 'EDIT_UPLOAD_DOCUMENTS',
  hasRightToAddOrRemoveDocuments: 'ADD_OR_REMOVE_DOCUMENTS',
  hasRightToAddComment: 'ADD_COMMENT',
  hasRightToDeleteComment: 'DELETE_COMMENT',
  hasRightToViewComments: 'VIEW_COMMENTS',
  hasRightToViewStateTransitionsHistory: 'VIEW_STATE_TRANSITIONS_HISTORY',
  hasRightToEditWorkflow: 'EDIT_WORKFLOW',
  hasRightToViewChecks: 'VIEW_CHECKS',
  hasRightToEditChecks: 'EDIT_CHECKS',
  hasRightToEditRenewal: 'EDIT_RENEWAL',
  hasRightToViewLogs: 'MENU_LOGS',
  hasRightToViewInsuranceServiceLogs: 'VIEW_INSURANCE_SERVICE_LOGS'
};
